// extracted by mini-css-extract-plugin
var _1 = "ra-consent-msg-buttons";
var _2 = "ra-consent-msg-buttons-single";
var _3 = "ra-consent-msg";
var _4 = "ra-consent-msg-main-btn";
var _5 = "ra-consent-msg-text";
export { _1 as "consentMsgButtonsCls", _2 as "consentMsgButtonsSingleCls", _3 as "consentMsgCls", _4 as "consentMsgMainBtnCls", _5 as "consentMsgTextCls" }
